/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const lead_count_tool_init = typeof exports !== 'undefined' && exports !== null ? exports : this;

lead_count_tool_init.initializeLeadCountTool = () => $(function() {
  if (!window.leadMap) {
    window.leadMap = new LeadMap();
    window.leadMap.addMarkersToggleController('#toggle-map-markers');
    window.leadMap.initMap();
  }

  const $spinner = $('#loading-spinner');

  $.ajaxSetup({beforeSend(xhr) {
    return xhr.setRequestHeader('Authorization', window.leadApiToken);
  }
  });

  // zipcodes
  const $leadFormZipCode = new LeadForm($('#lead-form'));
  $leadFormZipCode.zipCodeInput = $('#lead-form').find('#zipcode-input');
  $leadFormZipCode.bindSubmit('#lead-form-submit-btn');

  if ($spinner.length > 0) {
    $leadFormZipCode.spinner = $spinner;
  }

  $leadFormZipCode.zipCodeInput.on('keyup', function(){
    const zipCodes = LeadForm.sanitizeZipCodes(this.value);
    if (zipCodes) {
      window.leadMap.zoomOutUsa();
      return LeadForm.getZipGeometryAndDraw(zipCodes, window.leadMap);
    } else {
      return window.leadMap.removeAllPolygons();
    }
  });

  if (new URL(window.location.href).searchParams.get('run') === 'true') { return $('#lead-form-submit-btn').click(); }
});
